module.exports = __webpack_public_path__ + "static/media/1250_screenshots_2012-08-03_00006.f98c8ebf.jpg";